import { useDeliveryMethodsQuery } from '../services/jobsLookUpTables';

export const useDeliveryMethods = () => {
  const { data: deliveryMethods, isLoading, error } = useDeliveryMethodsQuery();

  const getDeliveryMethodName = (deliveryMethodId) => {
    if (!deliveryMethods || isLoading) return '';
    const method = deliveryMethods.find(method => method.id === deliveryMethodId);
    return method ? method.name : '';
  };

  return {
    deliveryMethods,
    isLoading,
    error,
    getDeliveryMethodName
  };
};
